import { Injectable } from '@angular/core';
import { Data } from '@angular/router';
import { ApiService } from '@targx/services/api/api.service';
import qs from 'qs';
import { map, Observable } from 'rxjs';
import { ProductSimple } from 'app/pages/marketplace/product.model';
import { TenantService } from '@core/tenant/tenant.service';

interface SolrResponse {
  facet_counts: Data;
  response: {
    docs: Data;
    numFound: number;
    numFoundExact: boolean;
    start: number;
  };
  responseHeader: Data;
}

/**
 * Pesquisa Solr sempre filtrada pelo dealer atual (seller_id_i).
 *
 * Não filtra por `approved_b:true` — ao contrário do marketplace, o
 * autodepoca mostra também veículos Vendidos/Restauro (ver menu
 * STOCK/VENDIDOS/RESTAUROS), pelo que a pesquisa não pode excluir
 * produtos não aprovados publicamente no marketplace geral.
 */
@Injectable({ providedIn: 'root' })
export class DealerSearchService {
  constructor(
    private _api: ApiService,
    private _tenantService: TenantService,
  ) {}

  private get _sellerId(): number | null {
    return this._tenantService.profile?.id ?? null;
  }

  searchSolr(
    query = '',
    page = 0,
    limit = 24,
    sort = 'published_at_dt desc',
    extraFq: string[] = [],
  ): Observable<Data> {
    const sellerId = this._sellerId;

    const data: Data = {
      q: '*:*',
      start: page * limit,
      rows: limit,
      sort,
    };

    if (query.length) {
      data.q = `*${query}*`;
    }

    const fq: string[] = [...extraFq];
    // Dealer scope — sempre presente, mesmo sem query nem outros filtros.
    if (sellerId) {
      fq.push(`seller_id_i:${sellerId}`);
    }

    data.fq = fq;

    const dataQuery = qs.stringify(data, { encodeValuesOnly: true });

    return this._api
      .getSolr<SolrResponse>('/products', '', '?' + dataQuery, false)
      .pipe(
        map((response: SolrResponse) => {
          const res: Data = {
            facets: response.facet_counts,
            products: response.response.docs,
            numFound: response.response.numFound,
            numFoundExact: response.response.numFoundExact,
            start: response.response.start,
          };

          res.products = res.products.map((product: Data) => {
            const p = Object.assign(new ProductSimple(), product);
            p.bootstrap();
            return p;
          });

          return res;
        }),
      );
  }
}
